import { defineMessages } from 'react-intl';

const messages = defineMessages({
  subtitle_sws: {
    id: 'mQxRPU',
    defaultMessage: 'Pricing does not include the cost of infrastructure.',
  },
  no: {
    id: 'oUWADl',
    defaultMessage: 'No',
  },
  returnToEstimator: {
    id: '8fgwsI',
    defaultMessage: 'Return to price estimator',
  },
  yes: {
    id: 'a5msuh',
    defaultMessage: 'Yes',
  },
  estimatedCosts: {
    id: 'wNB/GH',
    defaultMessage: 'Estimated monthly cost',
  },
  inline_saas: {
    id: 'pzhawg',
    defaultMessage: 'Software as a Service information',
  },
  inline_sws: {
    id: 'CI1KvW',
    defaultMessage: 'Software subscription information',
  },
  tooltipBreach: {
    id: 'Br2gcD',
    defaultMessage:
      ' Include Breach Response for fast, proactive response to privacy breaches ',
  },
  subheadline_sws: {
    id: 'XG3m6s',
    defaultMessage: 'SOAR (Software)',
  },
  saas_bullet_one: {
    id: '68ud1D',
    defaultMessage:
      'All the benefits of QRadar SOAR without needing to invest in hardware and software',
  },
  contactBP: {
    id: 'MsiLjH',
    defaultMessage: 'Contact IBM Business Partner',
  },
  tooltipWorkStations: {
    id: 'Hs0rnQ',
    defaultMessage:
      'Authorized User is a single, specific individual who is given access to use the QRadar SOAR product. There is no limit to the amount of users your organization may add and should be based on your security program’s unique needs.',
  },
  welcomeMsg1: {
    id: 'uCPV8p',
    defaultMessage:
      'How many people in your organization require access, based on your unique requirements?',
  },
  getQuoteButton: {
    id: 'aAghQx',
    defaultMessage: 'Request a quote now',
  },
  footnoteOne: {
    id: 'r4DIUE',
    defaultMessage:
      'Estimated costs are not a formal offer from IBM or an IBM Business Partner. Certain factors such as QRadar configuration, add-ons, and discounts may affect estimated costs. IBM Business Partners set and provide their own IBM QRadar SOAR pricing, and neither IBM nor IBM Business Partners are bound by the provided estimate.',
  },
  asteriskPrice: {
    id: 'k6nzq4',
    defaultMessage: ' Prices shown do not include tax.',
  },
  currency: {
    id: 'hCQDkn',
    defaultMessage: 'USD',
  },
  preferred_bp: {
    id: '9Auwhe',
    defaultMessage: 'Preferred IBM Business Partner',
  },
  triggertextWorkstations: {
    id: 'c2GwPk',
    defaultMessage: 'Enter # of Authorized Users',
  },
  includeBreach: {
    id: 'o2pMn9',
    defaultMessage: 'Include Breach Response',
  },
  tooltipBreachInfo: {
    id: 'Ghp1gN',
    defaultMessage:
      'IBM Security SOAR Breach Response provides organizations with support for over 180 privacy regulations worldwide, allowing security teams to integrate privacy reporting tasks into their overall incident response playbooks and work together with privacy, HR and legal teams to help them address regulatory requirements.',
  },
  scopingQuestions: {
    id: 'SLvWs/',
    defaultMessage: 'Size your solution',
  },
});

export default messages;
